import useFetch from '@hooks/useFetch';

const useSessionDetails = (sessionUID) => {
  const key = `v2/live_interaction/session/${sessionUID}/user_details/`;
  const { data = [], ...rest } = useFetch(
    sessionUID ? key : null,
    {},
    {
      revalidateOnMount: true
    }
  );

  return { sessionDetails: data, ...rest };
};

export default useSessionDetails;
